export const selectPortTnCmpDropdown = (state) => {
  const wrapperDropdown = state.fieldInfo?.currentMobileProviderDropdown.map(({ id, name }) => {
    if (id !== -1) {
      return { id: id + 1, name };
    }
    return { id, name };
  });
  return wrapperDropdown;
};
